import { Currency } from '@enums/salary'

export enum ExpensesReason {
  PHONE = 'phone',
  CRM = 'crm',
  BASE = 'base',
  ARENDA = 'arenda',
  ZONT = 'zont',
  ZP_IT = 'zp-it',
  OTHER = 'other',
}

export interface ExpensesDto {
  amountPayable: number
  reason: ExpensesReason
  crmInfo: { id: string; name: string }
  comment: string
  createdAt: string
  crmId: string
  currency: Currency
  dateOfCreation: string
  id: string
  updatedAt: string
}

export interface ITotalExpenses {
  total: {
    amountpayable: number
  }
}
